import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PhysicianService } from 'src/app/services/physician.service';
import { ValidateAutoCompleteSelect } from 'src/app/validators/autocomplete-select.validator';
import { StudyReportService } from '../../../services/study-report/study-report.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-report-physician-replacement-dialog',
  templateUrl: './report-physician-replacement-dialog.component.html',
  styleUrls: ['./report-physician-replacement-dialog.component.css']
})
export class ReportPhysicianReplacementDialogComponent implements OnInit {

  loading: boolean;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  existsPhysicians: boolean;
  form: FormGroup;

  constructor(private physicianService: PhysicianService
    , private studyReportService: StudyReportService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<ReportPhysicianReplacementDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      Physician: ['', [Validators.required, ValidateAutoCompleteSelect]]
    });

    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>([], this.form.controls.Physician);
  }

  get filteredPhysiciansOptions() { return this.filterCompletePhysicians ? this.filterCompletePhysicians.filteredOptions : []; }
  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.loading = true;

       let response = await this.studyReportService.setReportPhysician(
            (<PhysicianFilter>this.form.getRawValue().Physician).Id
          , this.data.studyReports.map(s => s.StudyReportId)
        );
        
        if (response.BlockIds.length === 0) {
          this.notificationToastService.success('Se ha reemplazado el médico correctamente', 'Reemplazo de médico');
          this.dialogRef.close( (<PhysicianFilter>this.form.getRawValue().Physician));
        } else { 
          this.notificationToastService.error('Existen informes bloqueados', 'Reemplazo de médico');
          this.notificationToastService.info(
            this.data.studyReports
            .filter(s => response.BlockIds.indexOf(s.StudyReportId) > -1 )
            .map(s => s.Protocol ).join('<br>'),
             'Protocolos bloqueados', true, true, true);
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Reemplazo de médico');
    } finally {
      this.loading = false;
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      
      const physiciansFilter = await this.physicianService
        .getPosibleReportPhysicianByReportIdsFilters(this.data.studyReports.map(s => s.StudyReportId));
      
      this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(
        physiciansFilter,
        this.form.controls.Physician);
        
      this.form.patchValue({ Physician: null });
      this.existsPhysicians = physiciansFilter.length > 0;

    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Reemplazo de médico');
    } finally {
      this.loading = false;
    }
  }
}
